import * as AppConstants from "AppConstants";
import { authHeader } from "app/services/auth.header.service";

/**
 * Skill Service - Skill Matrix API calls
 */

// Skill Management
export const fetchAllSkills = async () => {
    const response = await fetch(AppConstants.GET_ALL_SKILLS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchActiveSkills = async () => {
    const response = await fetch(AppConstants.GET_ACTIVE_SKILLS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchSkillById = async (skillId) => {
    const url = AppConstants.GET_SKILL_BY_ID_ENDPOINT.replace(AppConstants.SKILL_ID_PLACEHOLDER, skillId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchSkillsByCategory = async (category) => {
    const url = `${AppConstants.GET_SKILLS_BY_CATEGORY_ENDPOINT}/${category}`;
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createSkill = async (skillData) => {
    const response = await fetch(AppConstants.CREATE_SKILL_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(skillData),
    });
    return response.json();
};

export const updateSkill = async (skillId, skillData) => {
    const url = AppConstants.UPDATE_SKILL_ENDPOINT.replace(AppConstants.SKILL_ID_PLACEHOLDER, skillId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(skillData),
    });
    return response.json();
};

export const deleteSkill = async (skillId) => {
    const url = AppConstants.DELETE_SKILL_ENDPOINT.replace(AppConstants.SKILL_ID_PLACEHOLDER, skillId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// Member Skills Management
export const fetchMemberSkills = async (memberId) => {
    const url = AppConstants.GET_MEMBER_SKILLS_ENDPOINT.replace(AppConstants.MEMBER_ID_PLACEHOLDER, memberId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchMembersBySkill = async (skillId) => {
    const url = AppConstants.GET_MEMBERS_BY_SKILL_ENDPOINT.replace(AppConstants.SKILL_ID_PLACEHOLDER, skillId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createMemberSkill = async (memberSkillData) => {
    const response = await fetch(AppConstants.CREATE_MEMBER_SKILL_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(memberSkillData),
    });
    return response.json();
};

export const updateMemberSkill = async (memberSkillId, memberSkillData) => {
    const url = AppConstants.UPDATE_MEMBER_SKILL_ENDPOINT.replace(AppConstants.MEMBER_SKILL_ID_PLACEHOLDER, memberSkillId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(memberSkillData),
    });
    return response.json();
};

export const verifyMemberSkill = async (memberSkillId, verifiedBy) => {
    const url = `${AppConstants.VERIFY_MEMBER_SKILL_ENDPOINT.replace(AppConstants.MEMBER_SKILL_ID_PLACEHOLDER, memberSkillId)}?verifiedBy=${verifiedBy}`;
    const response = await fetch(url, {
        method: "PATCH",
        headers: authHeader(),
    });
    return response.json();
};

export const deleteMemberSkill = async (memberSkillId) => {
    const url = AppConstants.DELETE_MEMBER_SKILL_ENDPOINT.replace(AppConstants.MEMBER_SKILL_ID_PLACEHOLDER, memberSkillId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// Certification Management
export const fetchAllCertifications = async () => {
    const response = await fetch(AppConstants.GET_ALL_CERTIFICATIONS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchMemberCertifications = async (memberId) => {
    const url = AppConstants.GET_MEMBER_CERTIFICATIONS_ENDPOINT.replace(AppConstants.MEMBER_ID_PLACEHOLDER, memberId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchExpiringCertifications = async (days = 30) => {
    const url = `${AppConstants.GET_EXPIRING_CERTIFICATIONS_ENDPOINT}?days=${days}`;
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createCertification = async (certificationData) => {
    const response = await fetch(AppConstants.CREATE_CERTIFICATION_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(certificationData),
    });
    return response.json();
};

export const updateCertification = async (certificationId, certificationData) => {
    const url = AppConstants.UPDATE_CERTIFICATION_ENDPOINT.replace(AppConstants.CERTIFICATION_ID_PLACEHOLDER, certificationId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(certificationData),
    });
    return response.json();
};

export const deleteCertification = async (certificationId) => {
    const url = AppConstants.DELETE_CERTIFICATION_ENDPOINT.replace(AppConstants.CERTIFICATION_ID_PLACEHOLDER, certificationId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// Skill categories - must match backend SkillCategory enum
export const SKILL_CATEGORIES = {
    TECHNICAL: "TECHNICAL",
    SOFT: "SOFT",
    DOMAIN: "DOMAIN",
    TOOL: "TOOL",
    LANGUAGE: "LANGUAGE",
    FRAMEWORK: "FRAMEWORK",
    METHODOLOGY: "METHODOLOGY",
    OTHER: "OTHER",
};

// Proficiency levels
export const PROFICIENCY_LEVELS = {
    BEGINNER: "BEGINNER",
    INTERMEDIATE: "INTERMEDIATE",
    ADVANCED: "ADVANCED",
    EXPERT: "EXPERT",
};

